import '../index.css';
import Header from './@common.blocks/Header/Header';
import Footer from './@common.blocks/Footer/Footer';
import SingleNavbar from './@common.blocks/SingleNavbar/SingleNavbar';

const Layout = (props) => {
  const { children } = props;
  return (
    <>
      <Header />
      <SingleNavbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};
export default Layout;
